module.exports = __webpack_public_path__ + "static/ss16.ddcc718c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/studysmart/ss/ss16.jpg
// module id = 1193
// module chunks = 81679748166845